export default __webpack_public_path__ + "images/D4.27b6cba.png";